import React from 'react';
import get from 'lodash/get';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import CopyIcon from '@ad-scripts/presentation/components/common/icons/copy';
import apiTokensResource from 'src/actions/integrations/apiTokensResource';

export const EMPTY_TOPIC = '**************************';

const TokenColumn = ({ apiToken }): JSX.Element => {
  const dispatch = useDispatch();

  const tokenString = apiToken.token ? apiToken.token : EMPTY_TOPIC;

  const handleCopyButtonClick = () => {
    dispatch(apiTokensResource.effects.copyToClipboard(apiToken));
  };

  return (
    <TokenColumnContainer onClick={() => !!apiToken.token && handleCopyButtonClick()}>
      <Token data-aid={`${get(apiToken, 'id')}-token`}>{tokenString}</Token>
      {!!apiToken.token && (
        <StyledCopyButton data-aid={`${get(apiToken, 'id')}-copyToClipboard`}>
          <CopyToClipboardButton />
        </StyledCopyButton>
      )}
    </TokenColumnContainer>
  );
};

export const StyledCopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  visibility: hidden;
  & svg {
    height: 16px;
  }
`;

const CopyToClipboardButton = styled(CopyIcon)`
  cursor: pointer;
  fill: ${p => p.theme.colors.gray800};
  height: 16px;
  width: 16px;
  visibility: hidden;
`;

const Token = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 16px);
`;

const TokenColumnContainer = styled.div`
  display: flex;
  width: 100%;

  &:hover {
    ${CopyToClipboardButton} {
      visibility: visible;
    }
  }
`;

export default TokenColumn;
